import React, {useState, useEffect} from "react"
import ReactMarkdown from 'react-markdown'
import appConfig from '../../Config/config'
import {SnackbarMode, useGlobalSnackbar} from "../Snackbar/useGlobalSnackbar";
import Container from '@mui/material/Container'
import './ApiChangelog.css'

const ApiChangelog = () => {

    const [changelog, setChangelog] = useState('')

    const {showSnackbar} = useGlobalSnackbar()

    useEffect(() => {

        const fetchChangelog = async () => {
            try {
                const response = await fetch(`${appConfig.backendApiUrl}/CHANGELOG.md`)

                if(!response.ok) {
                    console.error(`HTTP-Error: ${response.status}`)}

                const text = await response.text();

                setChangelog(text)

                console.log(text)
            } catch (error) {
                console.error('Error with Changelog')

                showSnackbar("Failed to load Changelog. Please contact support", SnackbarMode.ERROR)
            }
        };
        fetchChangelog();
    }, [showSnackbar])

    return (
        <Container maxWidth='xl' sx={{marginTop: '50px'}}>
            <div className="markdown-body">
                <ReactMarkdown >
                    {changelog}
                </ReactMarkdown>
            </div>
        </Container>
    )
}

export {ApiChangelog}